import {SankeyLink, SankeyNode} from 'd3-sankey';
import React from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {Tooltip} from '../../../../../libs/shared/ui/src/components/tooltips/tooltip';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {SLinkExtra, SNodeExtra} from '../../charts/components/sankey/sankey';

/*
 * Props.
 */

interface SankeyTooltipProps {
  bounds: DOMRect;
  data: SankeyLink<SNodeExtra, SLinkExtra>;
}

/*
 * Styles.
 */

const StyledTooltipRow = styled.div`
  display: flex;
  align-items: center;
  font-size: ${fontSizes.verySmall};
`;

const StyledTooltipLabel = styled.div`
  color: ${(p) => p.theme.greys.shade80};
`;

const StyledTooltipValue = styled.div`
  color: ${(p) => p.theme.interactiveText};
  text-align: right;
  margin-left: 25px;
  font-weight: ${fontWeights.medium};
`;

const StyledIcon = styled(Icon)`
  margin: 0 7px;
`;

/*
 * Component.
 */

export const SankeyTooltip = ({bounds, data}: SankeyTooltipProps) => {
  const theme = useUserTheme();

  return (
    <Tooltip color="white" anchor={() => bounds} placement="auto">
      <StyledTooltipRow>
        <StyledTooltipLabel>{(data.source as SankeyNode<SNodeExtra, SLinkExtra>).name}</StyledTooltipLabel>
        <StyledIcon name="arrowForward" color={theme.greys.shade50} size={14} />
        <StyledTooltipLabel>{(data.target as SankeyNode<SNodeExtra, SLinkExtra>).name}</StyledTooltipLabel>
        <StyledTooltipValue>{data.value}</StyledTooltipValue>
      </StyledTooltipRow>
    </Tooltip>
  );
};
